<div class="container">
    <h1 class="my-3">Módulos instalados</h1>
    <hr>
    <div class="row my-5">
        <div class="row">
            <span>Angular Material OK</span>
        </div>
        <div class="row">
            <mat-slide-toggle>Toggle me!</mat-slide-toggle>
        </div>
    </div>
    <hr>
    <div class="row my-5">
        <div class="row">
            <span>Dialog Alerts</span>
        </div>
        <div class="row">
            <button (click)="openDialog()">Open</button>
        </div>
    </div>
    <hr>
    <div class="row my-5">
        <div class="row">
            <span>Normal Alerts</span>
        </div>
        <div class="row">
            <button (click)="openAlert()">Open</button>
        </div>
    </div>
    <hr>
    <div class="row my-5">
        <div class="row">
            <span>Bootstrap installed OK</span>
        </div>
        <div class="row">
            <div class="container">
                <h1>Install and Add Bootstrap 5 in Angular 17 - Tutsmake.com</h1>
                <div class="card">
                  <div class="card-header">
                    Featured
                  </div>
                  <div class="card-body">
                    <h5 class="card-title">Special title treatment</h5>
                    <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
                    <a href="#" class="btn btn-primary">Go somewhere</a>
                  </div>
                </div>
            </div>
        </div>
    </div>
</div>